import { Bug, Mail, MessageSquare, X } from 'lucide-react';
import { useEffect } from 'react';

/**
 * Props:
 * - usuario (recomendado): { nombre, email, rol, organizacion } shape genérico.
 * - ejecutivo (legacy, retrocompat): se traduce a usuario internamente.
 *
 * Pre-llena el mailto de "Reportar problema" con datos de contexto.
 */
export default function SoporteModal({ usuario, ejecutivo, onClose }) {
  useEffect(() => {
    function onEsc(e) { if (e.key === 'Escape') onClose?.(); }
    document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [onClose]);

  // Traducir ejecutivo legacy al shape genérico
  const u = usuario || (ejecutivo ? {
    nombre: ejecutivo.nombre,
    email: ejecutivo.email,
    rol: ejecutivo.rol,
    organizacion: ejecutivo.inmobiliaria?.nombre_empresa,
  } : {});

  const reportarMailto = `mailto:hola@ia-vera.com?subject=Reporte%20de%20problema%20-%20Vera.ia&body=${encodeURIComponent(
    `Hola equipo Vera,\n\nDescribo un problema que detecté:\n\n[describe aquí lo que pasó, qué hacías cuando ocurrió, en qué pantalla, etc.]\n\n---\nDatos para contexto:\nUsuario: ${u.email ?? '—'}\nNombre: ${u.nombre ?? '—'}\nRol: ${u.rol ?? '—'}\nOrganización: ${u.organizacion ?? '—'}\nFecha: ${new Date().toLocaleString('es-CL')}\n`
  )}`;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: 'var(--bg-card)', borderRadius: 12, padding: 24,
        width: '100%', maxWidth: 420, border: '0.5px solid var(--border-200)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: 'var(--text-strong)' }}><MessageSquare size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /> Soporte</h2>
          <button type="button" onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--ink-400)' }}><X size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /></button>
        </div>

        <p style={{ fontSize: 13, color: 'var(--ink-500)', lineHeight: 1.5, marginTop: 0, marginBottom: 18 }}>
          ¿Necesitas ayuda o detectaste algo que no funciona? Estamos al otro lado del mail.
        </p>

        <a href="mailto:hola@ia-vera.com"
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '14px 16px', marginBottom: 10,
            border: '0.5px solid var(--border-200)', borderRadius: 8,
            background: 'var(--bg-muted)', textDecoration: 'none',
            color: 'var(--text-strong)', fontSize: 14, fontFamily: 'inherit',
          }}>
          <span style={{ fontSize: 22 }}><Mail size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /></span>
          <div>
            <div style={{ fontWeight: 600 }}>Contactar al equipo</div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)' }}>hola@ia-vera.com</div>
          </div>
        </a>

        <a href={reportarMailto}
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '14px 16px',
            border: '0.5px solid var(--border-200)', borderRadius: 8,
            background: 'var(--bg-muted)', textDecoration: 'none',
            color: 'var(--text-strong)', fontSize: 14, fontFamily: 'inherit',
          }}>
          <span style={{ fontSize: 22 }}><Bug size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /></span>
          <div>
            <div style={{ fontWeight: 600 }}>Reportar un problema</div>
            <div style={{ fontSize: 12, color: 'var(--ink-400)' }}>Email pre-llenado con tus datos</div>
          </div>
        </a>

        <p style={{ fontSize: 11, color: 'var(--ink-400)', marginTop: 16, marginBottom: 0, textAlign: 'center' }}>
          Vera.ia · postventa inmobiliaria con IA
        </p>
      </div>
    </div>
  );
}
